import { Register8 } from '@/Emulator/Utility';

export class MaskRegister extends Register8
{
    public static readonly GREYSCALE_BIT: number                    = 0;
    public static readonly LEFT_MOST_BACKGROUND_VISIBLE_BIT: number = 1;
    public static readonly LEFT_MOST_SPRITES_VISIBLE_BIT: number    = 2;
    public static readonly BACKGROUND_VISIBLE_BIT: number           = 3;
    public static readonly SPRITES_VISIBLE_BIT: number              = 4;
    public static readonly EMPHASIZE_RED_BIT: number                = 5;
    public static readonly EMPHASIZE_GREEN_BIT: number              = 6;
    public static readonly EMPHASIZE_BLUE_BIT: number               = 7;

    constructor()
    {
        super(new Uint8Array(1), 0);
    }

    public isGrayscale(): boolean
    {
        return this.hasBit(MaskRegister.GREYSCALE_BIT);
    }

    public isLeftMostBackgroundVisible(): boolean
    {
        return this.hasBit(MaskRegister.LEFT_MOST_BACKGROUND_VISIBLE_BIT);
    }

    public isLeftMostSpritesVisible(): boolean
    {
        return this.hasBit(MaskRegister.LEFT_MOST_SPRITES_VISIBLE_BIT);
    }

    public isBackgroundVisible(): boolean
    {
        return this.hasBit(MaskRegister.BACKGROUND_VISIBLE_BIT);
    }

    public isSpritesVisible(): boolean
    {
        return this.hasBit(MaskRegister.SPRITES_VISIBLE_BIT);
    }

    public isEmphasizeRed(): boolean
    {
        return this.hasBit(MaskRegister.EMPHASIZE_RED_BIT);
    }

    public isEmphasizeGreen(): boolean
    {
        return this.hasBit(MaskRegister.EMPHASIZE_GREEN_BIT);
    }

    public isEmphasizeBlue(): boolean
    {
        return this.hasBit(MaskRegister.EMPHASIZE_BLUE_BIT);
    }
}
